import { create } from 'zustand';
import type { ExtractedWine } from './usePhotoTasting';

/**
 * Staging temporal del flow "saco foto → form completo".
 *
 * El usuario saca fotos, las analizamos con Claude, y antes de guardar lo
 * mandamos a WineFormPage con los datos pre-cargados + las fotos en memoria.
 * WineFormPage al guardar:
 *   1. Crea el wine.
 *   2. Sube las fotos como wine_images.
 *   3. Si la decisión incluye "probado", crea la tasting_note.
 *   4. Llama a clear() para vaciar el store.
 *
 * Las File objects NO son serializables, así que si el usuario refresca la
 * página el store se pierde. Es aceptable para un staging de paso.
 */
interface PhotoStaging {
  photos: File[];
  extracted: ExtractedWine | null;
  decision: 'cellar' | 'tasted_only' | 'both' | null;
  score: number | null;
  eventId: number | null;
  setStaging: (data: Partial<PhotoStaging>) => void;
  clear: () => void;
}

const initial = {
  photos: [],
  extracted: null,
  decision: null,
  score: null,
  eventId: null,
};

export const usePhotoStagingStore = create<PhotoStaging>((set) => ({
  ...initial,
  setStaging: (data) => set(data),
  clear: () => set(initial),
}));
